import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { MaskedLines, FadeUp } from "@/components/Reveal";

export default function CtaBand() {
  return (
    <section className="bg-pine-950 py-24 text-cream lg:py-32" data-testid="cta-band">
      <div className="mx-auto max-w-7xl px-6">
        <MaskedLines
          as="h2"
          inView
          lines={["Good decisions depend", "on good information."]}
          className="font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
        />
        <FadeUp delay={0.25}>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-cream/70">
            Have a question or interested in working with Arnold Bookkeeping? Reach out directly
            or complete the short Get Started form. Proudly serving small businesses in Wellsville
            and across Central Pennsylvania.
          </p>
        </FadeUp>
        <FadeUp delay={0.35}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-band-get-started-button"
              className="inline-flex items-center gap-2 rounded-md bg-gold px-7 py-4 text-sm font-semibold text-ink transition-transform duration-200 hover:-translate-y-0.5"
            >
              Get Started <ArrowUpRight size={16} />
            </Link>
            <a
              href="mailto:Arnold.Bookkeeping@outlook.com"
              data-testid="cta-band-email-link"
              className="inline-flex items-center gap-2 rounded-md border border-cream/25 px-6 py-4 text-sm font-semibold text-cream transition-colors duration-200 hover:border-gold hover:text-gold"
            >
              <Mail size={16} /> Arnold.Bookkeeping@outlook.com
            </a>
            <a
              href="tel:7175541224"
              data-testid="cta-band-phone-link"
              className="inline-flex items-center gap-2 rounded-md border border-cream/25 px-6 py-4 text-sm font-semibold text-cream transition-colors duration-200 hover:border-gold hover:text-gold"
            >
              <Phone size={16} /> 717.554.1224
            </a>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
